import React, { useEffect, useState } from "react";
import { Close } from "../../assets/svg";
import { RadioButton } from "../../components/micro/input";

const FlitterPanel = ({
  show,
  onClose,
  setRoles,
  setPaymentStatus,
  modifiedDate,
  setModifiedDate,
  onApply,
  setSelectedCategories,
  selectedCategories,
  allCategoriesList,
  allCategoriesLoading,
}) => {
  // Temporary local states
  const [tempModifiedDate, setTempModifiedDate] = useState(modifiedDate);
  const [tempSelectedCategories, setTempSelectedCategories] = useState([]);

  useEffect(() => {
    if (show) {
      // Sync initial values when panel opens
      setTempModifiedDate(modifiedDate);
      setTempSelectedCategories(selectedCategories);
    }
  }, [show, modifiedDate, selectedCategories]);

  const resetFilter = () => {
    setTempModifiedDate("latest_modified_date");
    setTempSelectedCategories([]);
    setRoles(["All"]);
    setPaymentStatus(["All"]);
    setModifiedDate("latest_modified_date");
    setSelectedCategories([]);
    onClose();
    onApply(); // Optional: Apply reset immediately
  };

  const toggleCategory = (category) => {
    setTempSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };

  const handleApply = () => {
    setModifiedDate(tempModifiedDate);
    setSelectedCategories(tempSelectedCategories);
    onApply();
    onClose();
  };

  return (
    <div>
      <div
        className={`fixed top-[64px] left-0 right-0 bottom-0 z-[9999] bg-black/40 backdrop-blur-sm ${
          show ? "block" : "hidden"
        }`}
      >
        <div className="absolute right-0 top-0 bottom-0 h-full w-[80%] md:w-[40%] sm:w-[500px] bg-white p-6 sm:p-10 shadow-lg z-50 overflow-y-auto transition-all">
          {/* Header */}
          <div className="flex justify-between items-center mb-4 border-b border-stepGray pb-2">
            <p className="text-lg sm:text-xl text-primaryBlack">Filter</p>
            <button onClick={onClose}>
              <Close />
            </button>
          </div>

          {/* Sort */}
          <div className="mb-6">
            <h4 className="text-sm mb-4 text-darkblack">SORT BY</h4>
            <div className="space-y-3 text-sm">
              {["latest_modified_date", "price_low", "price_high"].map(
                (val) => (
                  <div key={val} className="flex gap-2">
                    <RadioButton
                      type="radio"
                      name="sort"
                      value={val}
                      checked={tempModifiedDate === val}
                      onChange={() => setTempModifiedDate(val)}
                      className="space-x-0"
                    />
                    <label>
                      {val === "latest_modified_date"
                        ? "Latest"
                        : val === "price_low"
                        ? "Price: Low-High"
                        : "Price: High-Low"}
                    </label>
                  </div>
                )
              )}
            </div>
          </div>

          {/* Category */}
          <div className="mb-6">
            <h4 className="text-sm mb-4 text-darkblack">Category</h4>
            {allCategoriesLoading ? (
              <p className="text-sm text-gray-500">Loading categories...</p>
            ) : (
              allCategoriesList?.data?.map((cat) => (
                <label
                  key={cat?.id}
                  className="flex items-center gap-2 text-sm mb-3 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={tempSelectedCategories.includes(cat?.id)}
                    onChange={() => toggleCategory(cat?.id)}
                    className="accent-orange-600 w-4 h-4"
                  />
                  {cat?.name}
                </label>
              ))
            )}
          </div>

          {/* Buttons */}
          <div className="absolute bottom-0 left-0 w-full bg-white px-6 py-4 sm:py-6 border-t border-stepGray">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-2">
              <button
                onClick={resetFilter}
                className="w-full sm:w-1/2 text-sm bg-white text-primaryBlack border border-primaryBlack flex items-center justify-center px-6 py-2 rounded uppercase font-Proxima"
              >
                RESET ALL
              </button>
              <button
                onClick={handleApply}
                className="w-full sm:w-1/2 text-sm bg-themeBtn text-bgWhite flex items-center justify-center px-6 py-2 rounded uppercase font-Proxima"
              >
                APPLY
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlitterPanel;
